import { Navigate, Outlet, useLocation } from "react-router-dom";
import { useAuth } from "@/lib/AuthContext";

/**
 * Guards the admin surface. Uses the shared AuthContext but lives inside the
 * admin feature slice so admin ownership is clear and future admin-only
 * concerns (e.g. two-factor, per-table ACLs) can be added here without
 * touching the generic ProtectedRoute.
 */
export function isAdmin(user) {
    if (!user) return false;
    return user.role === "admin" || user.isAdmin === true;
}

export default function AdminRoute({ children }) {
    const { user, ready } = useAuth();
    const location = useLocation();

    if (!ready) return <div className="p-10 text-navy-500">Loading…</div>;

    if (!user) {
        return <Navigate to="/login" state={{ from: location.pathname }} replace />;
    }

    if (!isAdmin(user)) {
        // Send non-admins back to their own dashboard so we never leak the
        // fact that /admin exists.
        const home = user.role === "broker" ? "/broker" : "/member";
        return <Navigate to={home} replace />;
    }

    return children ?? <Outlet />;
}
